import React, { useContext, useEffect, useLayoutEffect, useState } from "react";
import plus from "../../Assets/timeline/plus-squared.svg";
import dots from "../../Assets/timeline/dots-vertical.svg";
import {
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownTrigger,
  DropdownSection,
  Image,
} from "@nextui-org/react";
import AddTaskEvent from "./TimelineFunctions/AddTaskEvent";
import axios from "axios";
import { PopUpContext } from "Context/PopUpContext";
import { toast } from "react-toastify";
import { useParams } from "react-router-dom";
import { LoadingContext } from "Context/LoadingContext";
import useSettings from "hooks/useSettings";
import { SettingsContext } from "Context/SettingsContext";

const Timeline = () => {
  const [isOpenAddEvent, setIsOpenAddEvent] = useState(false);

  const [targetId, setTargetId] = useState(null);
  const [itemKey, setItemKey] = useState(null);
  const [targetType, setTargetType] = useState(null);
  const [isUpdating, setIsUpdating] = useState(false);

  const { frondId } = useParams();
  const [isLoading, setIsLoading] = useState(false);
  const [frondTasks, setFrondTasks] = useState([]);
  let authToken = localStorage.getItem("token");

  const { isTimelineLoaded, setIsTimelineLoaded } = useContext(LoadingContext);

  useLayoutEffect(() => {
    if (!isTimelineLoaded) {
      setTimeout(() => {
        setIsTimelineLoaded(true);
      }, 2000);
    }
  }, [isTimelineLoaded]);

  const months = [
    "Jan", "Feb", "Mar", "Apr", "May", "Jun",
    "Jul", "Aug", "Sep", "Oct", "Nov", "Dec",
  ];

  const getFrondTasks = async () => {
    // Don't fetch if frondId is undefined
    if (!frondId) {
      setIsLoading(false);
      return;
    }

    setIsLoading(true);
    try {
      const { data } = await axios.get(
        `/projects/${frondId}/events`,
        {
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        }
      );

      setFrondTasks(data);
    } catch (error) {
      toast(error?.response?.data?.message, {
        autoClose: 1500,
        position: "bottom-right",
        hideProgressBar: true,
        className: "rounded-4xl custom-toast error-toast",
      });
    }
    setIsLoading(false);
  };

  useEffect(() => {
    getFrondTasks();
  }, [frondId]);

  const { isAddEvent, setEdtiTimeline, setIsAddTask } =
    useContext(PopUpContext);

  useEffect(() => {
    if (isAddEvent && frondId) {
      getFrondTasks();
    }
  }, [isAddEvent, frondId]);

  const deleteRecord = async () => {
    if (!targetId) return;
    try {
      await axios.delete(
        `/events/${targetId}`,
        {
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${authToken}`,
            "Content-Type": "application/json",
          },
        }
      );

      getFrondTasks();

      setIsAddTask(true);
      setTimeout(() => {
        setIsAddTask(false);
      }, 1000);

      toast("Event Deleted Successfully", {
        autoClose: 1500,
        position: "bottom-right",
        hideProgressBar: true,
        className: "rounded-4xl custom-toast success-toast",
      });
    } catch (error) {
      toast(error?.response?.data?.message, {
        autoClose: 1500,
        position: "bottom-right",
        hideProgressBar: true,
        className: "rounded-4xl custom-toast error-toast",
      });
    }
  };

  // Function to update event status
  const updateEventStatus = async (eventId, newStatus) => {
    if (!eventId || isUpdating) return;

    setIsUpdating(true);
    
    try {
      // Find the current event
      const currentEvent = frondTasks.find(item => item?.event?.id === eventId);
      
      if (!currentEvent) {
        toast("Event not found", {
          autoClose: 1500,
          position: "bottom-right",
          hideProgressBar: true,
          className: "rounded-4xl custom-toast error-toast",
        });
        return;
      }

      console.log("Current event:", currentEvent);
      console.log("Updating to status:", newStatus);

      // Prepare payload
      let payload = {
        title: currentEvent?.event?.title,
        description: currentEvent?.event?.description || "",
        due_date: currentEvent?.event?.due_date || null,
        status: newStatus,
        type: currentEvent?.event?.type
      };

      if (currentEvent?.event?.assigned_to) {
        payload.assigned_to = currentEvent.event.assigned_to;
      }

      console.log("Sending payload:", payload);

      const response = await axios.put(
        `/events/${eventId}`,
        payload,
        {
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${authToken}`,
            "Content-Type": "application/json",
          },
        }
      );

      console.log("Response:", response.data);

      const statusNames = {
        pending: "Pending",
        in_progress: "In Progress",
        completed: "Completed",
        archived: "Archived"
      };

      toast.success(`Event moved to ${statusNames[newStatus] || newStatus}`, {
        autoClose: 1500,
        position: "bottom-right",
        hideProgressBar: true,
        className: "rounded-4xl custom-toast success-toast",
      });

      getFrondTasks();
      
    } catch (error) {
      console.error("Status update error:", error);
      console.error("Error response:", error.response?.data);
      
      // Show more detailed error message
      const errorMessage = error.response?.data?.message || 
                          error.response?.data?.errors?.status?.[0] || 
                          "Failed to update event status";
      
      toast.error(errorMessage, {
        autoClose: 1500,
        position: "bottom-right",
        hideProgressBar: true,
        className: "rounded-4xl custom-toast error-toast",
      });
    } finally {
      setIsUpdating(false);
      setTargetId(null);
    }
  };

  useEffect(() => {
    if (itemKey === "delete") {
      deleteRecord();
      setItemKey(null);
    } else if (itemKey === "edit") {
      setIsOpenAddEvent(true);
      setItemKey(null);
    } else if (itemKey === "pending" || itemKey === "in_progress" || itemKey === "completed" || itemKey === "archived") {
      updateEventStatus(targetId, itemKey);
      setItemKey(null);
    }
  }, [itemKey]);

  const openModal = (key, id, type) => {
    setItemKey(key);
    setTargetId(id);
    setTargetType(type);
    
    if (type === "milestone") {
      setEdtiTimeline("milestone");
    } else {
      setEdtiTimeline("task");
    }
  };

  const handleDotsClick = (e) => {
    e.stopPropagation();
    e.preventDefault();
  };

  useSettings({ projectId: frondId });
  const { frondSettings } = useContext(SettingsContext);

  const [showTimeline, setShowTimeline] = useState(false);

  useEffect(() => {
    if (frondSettings.can_edit_timeline && !frondSettings.is_owner) {
      setShowTimeline(true);
    } else if (frondSettings.is_owner) {
      setShowTimeline(true);
    } else {
      setShowTimeline(false);
    }
  }, [frondSettings]);

  // Function to get status dot color
  const getStatusDotColor = (status) => {
    switch(status) {
      case 'pending': return 'bg-blueTimeline';
      case 'in_progress': return 'bg-redTimeline';
      case 'completed': return 'bg-greenTimeline';
      case 'archived': return 'bg-pinkTimeline';
      default: return 'bg-gray-500';
    }
  };

  // Don't render the timeline if frondId is undefined (not on a frond page)
  if (!frondId) {
    return null;
  }

  return (
    <>
      <section
        className={`timeline hidden lg:block p-5 right-5 lg:min-w-[317px] lg:max-w-[317px] bg-white rounded-4xl border-2 border-solid border-grayBorder sticky z-20 no-focus transition-all duration-400 ${
          !isTimelineLoaded ? "opacity-0" : "opacity-100"
        }`}
      >
        <div className="flex justify-between items-center gap-2.5 border-b-1 border-solid border-grayBorder mb-2.5 pb-2.5">
          <h3 className="font-bold text-textColor leading-[20.7px] text-lg">
            Timeline
          </h3>
          {showTimeline ? (
            <button
              type="button"
              onClick={() => {
                setTargetId(null);
                setIsOpenAddEvent(true);
              }}
              className="flex items-center justify-center w-[122px] h-[30px] py-1.5 px-1.5 rounded-4xl bg-darkBlue gap-1.5 shadow-addEventBtnShadow"
            >
              <Image
                src={plus}
                alt="Add Timeline"
                className="min-w-[18px] min-h-[18px] max-w-[18px] max-h-[18px]"
              />
              <h4 className="text-white leading-[18.4px] text-base font-normal">
                Add Event
              </h4>
            </button>
          ) : null}
        </div>
        {frondTasks?.length > 0 ? (
          <div className="content flex flex-col gap-3 max-h-[500px] overflow-y-auto pr-2">
            {frondTasks.map((item, idx) => {
              const currentStatus = item?.event?.status;
              const isArchived = currentStatus === 'archived';
              
              return (
                <div
                  key={idx}
                  className="flex items-center justify-between gap-2.5 min-h-14"
                >
                  {item?.event?.due_date ? (
                    <div className="text-textColor text-center flex-1">
                      <p className="font-bold leading-[22px]">
                        {parseInt(item?.event?.due_date?.split("-")[2], 10)}
                      </p>
                      <p className="text-sm leading-[22px]">
                        {
                          months[
                            parseInt(item?.event?.due_date?.split("-")[1], 10) - 1
                          ]
                        }
                      </p>
                    </div>
                  ) : (
                    <div className="text-textColor text-center flex-1">
                      <p className="font-bold leading-[22px]">DD</p>
                      <p className="text-sm leading-[22px]">MM</p>
                    </div>
                  )}
                  <div
                    className={`flex gap-[14px] ${
                      item?.event?.type === "milestone" && "items-center"
                    }`}
                  >
                    {item?.event?.type === "milestone" ? (
                      <div
                        className={`min-w-[14.14px] max-w-[14.14px] min-h-[14.14px] max-h-[14.14px] ${getStatusDotColor(currentStatus)} rotate-[45deg]`}
                      ></div>
                    ) : (
                      <div
                        className={`min-w-1.5 max-w-1.5 min-h-full ${getStatusDotColor(currentStatus)} rounded-[10px]`}
                      ></div>
                    )}
                    <button
                      onClick={() => {
                        if (showTimeline) {
                          openModal("edit", item?.event?.id, item?.event?.type);
                        }
                      }}
                      className={`bg-white py-1.5 px-[7px] rounded-lg shadow-eventBoxShadow flex justify-between items-start gap-5 w-[205px] ${
                        showTimeline ? "cursor-pointer" : "cursor-auto"
                      }`}
                    >
                      <p className="text-textColor text-sm leading-[22px] break-before-all text-left">
                        {item?.event?.title?.length > 67
                          ? item?.event?.title.slice(0, 67) + "..."
                          : item?.event?.title}
                      </p>
                      {showTimeline ? (
                        <Dropdown
                          classNames={{
                            content: "min-w-[140px] py-0 px-[5px] rounded-[10px]",
                          }}
                          placement="left-start"
                        >
                          <DropdownTrigger>
                            <button
                              className="w-[24px] h-[24px] focus:outline-none"
                              onClick={handleDotsClick}
                              disabled={isUpdating}
                            >
                              <img
                                src={dots}
                                alt="Dots"
                                className="min-w-[24px] min-h-[24px]"
                              />
                            </button>
                          </DropdownTrigger>
                          <DropdownMenu
                            aria-label="Event Actions"
                            onAction={(key) =>
                              openModal(key, item?.event?.id, item?.event?.type)
                            }
                            disabledKeys={isUpdating ? ["edit", "delete", "pending", "in_progress", "completed", "archived"] : []}
                          >
                            {/* Status Change Section - Different based on current status */}
                            <DropdownSection title={isArchived ? "Move to Active" : "Change Status"} showDivider>
                              {isArchived ? (
                                // If archived: Show options to unarchive (Pending, In Progress, Completed)
                                <>
                                  <DropdownItem
                                    key="pending"
                                    className="text-blueTimeline text-sm font-normal py-[2px] px-[5px]"
                                    startContent={
                                      <span className="w-2 h-2 rounded-full bg-blueTimeline inline-block mr-2"></span>
                                    }
                                  >
                                    Pending
                                  </DropdownItem>
                                  <DropdownItem
                                    key="in_progress"
                                    className="text-redTimeline text-sm font-normal py-[2px] px-[5px]"
                                    startContent={
                                      <span className="w-2 h-2 rounded-full bg-redTimeline inline-block mr-2"></span>
                                    }
                                  >
                                    In Progress
                                  </DropdownItem>
                                  <DropdownItem
                                    key="completed"
                                    className="text-greenTimeline text-sm font-normal py-[2px] px-[5px]"
                                    startContent={
                                      <span className="w-2 h-2 rounded-full bg-greenTimeline inline-block mr-2"></span>
                                    }
                                  >
                                    Completed
                                  </DropdownItem>
                                </>
                              ) : (
                                // If not archived: Show only Archive option
                                <DropdownItem
                                  key="archived"
                                  className="text-pinkTimeline text-sm font-normal py-[2px] px-[5px]"
                                  startContent={
                                    <span className="w-2 h-2 rounded-full bg-pinkTimeline inline-block mr-2"></span>
                                  }
                                >
                                  Archive
                                </DropdownItem>
                              )}
                            </DropdownSection>

                            {/* Edit Option */}
                            <DropdownItem
                              textValue="edit"
                              key="edit"
                              className="text-textColor text-sm font-normal py-[2px] px-[5px] relative after:absolute after:left-0 after:right-0 after:bottom-[-2.5px] after:h-px after:bg-grayBorder my-[5px] selected-action"
                            >
                              Edit
                            </DropdownItem>
                            
                            {/* Delete Option */}
                            <DropdownItem
                              key="delete"
                              className="text-[#EB6270] text-sm font-normal py-[2px] px-[5px] selected-action"
                              color="danger"
                            >
                              Delete
                            </DropdownItem>
                          </DropdownMenu>
                        </Dropdown>
                      ) : null}
                    </button>
                  </div>
                </div>
              );
            })}
          </div>
        ) : !isLoading && (
          <div className="text-center py-8 text-gray-500">
            No timeline events found
          </div>
        )}
      </section>
      {isOpenAddEvent && !targetId && (
        <AddTaskEvent
          isOpen={isOpenAddEvent}
          onClose={() => {
            setIsOpenAddEvent(false);
            getFrondTasks();
          }}
          isModalOpen={true}
        />
      )}
      {isOpenAddEvent && targetId && (
        <AddTaskEvent
          isOpen={isOpenAddEvent}
          onClose={() => {
            setIsOpenAddEvent(false);
            getFrondTasks();
          }}
          targetId={targetId}
          isModalOpen={true}
        />
      )}
    </>
  );
};

export default Timeline;